import {GET_CONTROL_BY_ID, UPDATE_CONTROL, GET_ALL_CONTROLS} from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import {getQueryString} from '../apiUrls';
import {API_RESOURCES, createApiReadAction} from '../../util/api';

export const getControlById = (engagementId, controlId, documentId, expand) => {
	if (typeof expand === 'string') {
		expand = expand.toLowerCase();
	}

	const queryString = getQueryString({documentId, expand});
	const url = `${env.getBaseURL(serviceURL, engagementId)}Controls/${controlId}${queryString}`;

	return {
		type: GET_CONTROL_BY_ID,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const updateControl = (engagementId, controlId, data) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}Controls/${controlId}`;
	return {
		type: UPDATE_CONTROL,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: data
			}
		}
	};
};

export const getAllControls = (engagementId, args, filters) => {
	return createApiReadAction(
		GET_ALL_CONTROLS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.CONTROL]: undefined
		},
		filters,
		args
	);
};

export const getEngagementControls = (engagementId) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}Controls?expand=itapplications`;

	return {
		type: GET_ALL_CONTROLS,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};
